import { render, staticRenderFns } from "./EnfermeriaShow.vue?vue&type=template&id=a3c89a54"
import script from "./EnfermeriaShow.vue?vue&type=script&lang=ts"
export * from "./EnfermeriaShow.vue?vue&type=script&lang=ts"
import style0 from "./EnfermeriaShow.vue?vue&type=style&index=0&id=a3c89a54&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports